import React from 'react'
import PropTypes from 'prop-types'
import {Link, Text} from '@chakra-ui/react'

const LinkCell = ({url, text}) => {
  if (!url) {
    return <Text>{text}</Text>
  }

  return (
    <Link
      style={{textDecoration: 'underline'}}
      onClick={(e) => {
        e.stopPropagation()
      }}
      href={url}
      target="_blank"
    >
      {text}
    </Link>
  )
}

LinkCell.propTypes = {
  url: PropTypes.string,
  text: PropTypes.string.isRequired,
}

LinkCell.defaultProps = {
  url: null,
}

export default LinkCell
